import { doc, setDoc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { storage } from '../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export async function saveUserToFirestore(user) {
  await setDoc(doc(db, "users", user.uid), {
    uid: user.uid,
    email: user.email,
    dateCreated: new Date().toISOString(),
  }, { merge: true });
}

export async function updateUserProfile(uid, fields) {
  const userRef = doc(db, "users", uid);
  await updateDoc(userRef, fields);
}

export async function getUserProfile(uid) {
  const userRef = doc(db, "users", uid);
  const userSnap = await getDoc(userRef);
  if (userSnap.exists()) {
    return userSnap.data();
  } else {
    return null;
  }
}

export async function uploadImageToStorage(file, path) {
  try {
    // Check file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      throw new Error('גודל הקובץ חייב להיות קטן מ-5MB');
    }

    // Check if file is an image
    if (!file.type.startsWith('image/')) {
      throw new Error('הקובץ חייב להיות תמונה');
    }

    const storageRef = ref(storage, path);
    
    // Add retry logic
    let retryCount = 0;
    const maxRetries = 3;
    
    while (retryCount < maxRetries) {
      try {
        const uploadTask = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(uploadTask.ref);
        return downloadURL;
      } catch (error) {
        retryCount++;
        if (retryCount === maxRetries) {
          throw new Error('נכשל בהעלאת התמונה. אנא נסה שוב מאוחר יותר');
        }
        // Wait before retrying (exponential backoff)
        await new Promise(resolve => setTimeout(resolve, Math.pow(2, retryCount) * 1000));
      }
    }
  } catch (error) {
    console.error('שגיאה בהעלאת תמונה:', error);
    throw error;
  }
} 